// Icons + colors aligned with dripshipper-react react-toastify defaults.
const CLOSE_SVG = `<svg viewBox="0 0 14 14" fill="none" aria-hidden="true">
  <path d="M3 3L11 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M11 3L3 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>`

const TOASTIFY_ICON_PATHS = {
  error:
    "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z",
  success:
    "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z",
  warning:
    "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z",
  info:
    "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z",
}

function toastifyIcon(variant) {
  const path = TOASTIFY_ICON_PATHS[variant] || TOASTIFY_ICON_PATHS.error
  return `<svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor" aria-hidden="true"><path d="${path}"></path></svg>`
}

export function normalizeToastType(messageType) {
  const type = (messageType || "error").toString().toLowerCase()
  if (type === "success") return "success"
  if (type === "warning") return "warning"
  if (type === "info" || type === "notice") return "info"
  return "error"
}

export function buildAuthToastElement(text, messageType = "error", dismissAfterMs = 5000) {
  const variant = normalizeToastType(messageType)
  const toast = document.createElement("div")
  toast.className = `auth-toast auth-toast--${variant}`
  toast.setAttribute("role", "alert")
  toast.dataset.authToastTarget = "toast"
  toast.style.setProperty("--auth-toast-duration", `${dismissAfterMs}ms`)

  toast.innerHTML = `
    <div class="auth-toast__body">
      <div class="auth-toast__icon">${toastifyIcon(variant)}</div>
      <div class="auth-toast__content"></div>
      <button type="button" class="auth-toast__close" data-auth-toast-close aria-label="close">${CLOSE_SVG}</button>
    </div>
    <div class="auth-toast__progress-bar" role="progressbar" aria-hidden="true"></div>
  `

  toast.querySelector(".auth-toast__content").textContent = text
  return toast
}
